import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, type createRouter } from "@tanstack/react-router";
import type { FunctionComponent } from "./common/types/types";
import { SidebarProvider } from "./components/ui/sidebar";
import { init as initSentry } from "./services/sentry";
import { AuthProvider } from "@/providers/AuthProvider";

initSentry();

const queryClient = new QueryClient();

type AppProps = { router: ReturnType<typeof createRouter> };

const App = ({ router }: AppProps): FunctionComponent => {
  return (
    <AuthProvider>
      <SidebarProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </SidebarProvider>
    </AuthProvider>
  );
};

export default App;
